(function() {
  //Link directly to an accordion panel, and open it while scrolling it into view
  document.addEventListener("DOMContentLoaded", function(event){
    var urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('panel')) {
      var target_panel_id = urlParams.get('panel').replace(/[^a-z0-9-]/gi, '');
      var target_panel = document.getElementById(target_panel_id);
          if (target_panel != null) {
            target_panel.click();
            target_panel.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
          }          
    }
  });
})();
